import { Map as map } from 'immutable';
const C = require("../constants");

function SendInvoiceByEmailReducer(state = map(), action) {
    switch (action.type) {
        case C.SHOW_MODAL_INVOICE_BY_EMAIL:
            return action.modal;
        default:
            return state;
    }
}

export default SendInvoiceByEmailReducer;


// WEBPACK FOOTER //
// ./src/reducers/SendInvoiceByEmailReducer.js